import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
import create from "../../create";
export default create({
  name: "radar",
  x2: function x2() {
    return this.option.gridX2 || '80%';
  },
  methods: {
    updateChart: function updateChart() {
      var _this = this;

      var optionData = this.deepClone(this.dataChart);
      var option = {
        title: this.ishasprop(this.option.titleShow, {
          text: this.option.title,
          subtext: this.option.subtext || '',
          textStyle: {
            color: this.option.titleColor || '#333',
            fontSize: this.option.titleFontSize || 16
          },
          left: this.option.titlePostion || 'auto',
          subtextStyle: {
            color: this.option.subTitleColor || '#aaa',
            fontSize: this.option.subTitleFontSize || 14
          }
        }, {}),
        tooltip: function () {
          return Object.assign(function () {
            if (_this.formatter) {
              return {
                formatter: function formatter(name) {
                  return _this.formatter(name, _this.dataChart);
                }
              };
            }

            return {};
          }(), {
            backgroundColor: _this.option.tipBackgroundColor || 'rgba(50,50,50,0.7)',
            textStyle: {
              fontSize: _this.option.tipFontSize || 14,
              color: _this.option.tipColor || "#fff"
            }
          });
        }(),
        grid: {
          left: this.option.gridX || 20,
          top: this.option.gridY || 60,
          right: this.x2,
          bottom: this.option.gridY2 || 60
        },
        legend: {
          //雷达的legend是单系列的和其他不一样,不能合并
          show: this.vaildData(this.option.legend, false),
          top: 0,
          x: this.option.legendPostion || "right",
          right: this.x2,
          textStyle: {
            fontSize: this.option.legendFontSize || 12
          },
          data: function () {
            return (optionData.series[0].data || []).map(function (ele, index) {
              return {
                name: ele.name,
                textStyle: _this.ishasprop(!_this.option.switchTheme, {
                  color: _this.getColor(index, true)
                }, {})
              };
            });
          }()
        },
        radar: {
          name: {
            fontSize: this.option.radarNameSize || 12,
            color: this.option.radarNameColor || '#333'
          },
          indicator: optionData.indicator || [],
          shape: this.option.shape || 'polygon',
          radius: this.option.radius || '75%',
          triggerEvent: true
        },
        series: function () {
          var barColor = _this.option.barColor || [];
          var list = [{
            type: "radar",
            barWidth: _this.option.barWidth || 16,
            barMinHeight: _this.option.barMinHeight || 0,
            itemStyle: {
              barBorderRadius: _this.option.barRadius || 0
            },
            data: function () {
              return (optionData.series[0].data || []).map(function (ele, index) {
                return {
                  name: ele.name,
                  value: ele.value,
                  label: {
                    show: _this.vaildData(_this.option.labelShow, false),
                    //开启显示
                    textStyle: {
                      fontSize: _this.option.fontSize || 14,
                      color: _this.getColor(index),
                      fontWeight: _this.option.labelShowFontWeight || 500
                    }
                  },
                  areaStyle: {
                    color: _this.getColor(index),
                    opacity: _this.option.areaOpacity || 0.9
                  }
                };
              });
            }()
          }];
          return list;
        }()
      };
      this.myChart.resize();
      this.myChart.setOption(option, true);
    }
  }
});